import { useFetch } from '@fukuri-admins/hooks/common';
import {
  fetchUserDailyFirstAccessLog,
  UserDailyFirstAccessLogType,
} from '~/api/user_daily_first_access_logs';
import { useAuth } from '~/components/auth/AuthProvider';

type IUseGetUserDailyFirstAccessLogs = (args: { page?: number }) => {
  data?: UserDailyFirstAccessLogType;
  headers?: Record<string, string>;
  mutate: () => void;
  isLoading: boolean;
};

/**
 * ユーザーの日次初回アクセスログ一覧を取得する API hook
 */
export const useGetUserDailyFirstAccessLogs: IUseGetUserDailyFirstAccessLogs = ({ page }) => {
  const { signOut } = useAuth();

  const endpoint = `/user_daily_first_access_logs?page=${page ?? 1}`;

  const { data, mutate, isLoading } = useFetch<{
    data: UserDailyFirstAccessLogType;
    headers: Record<string, string>;
  }>(endpoint, () =>
    fetchUserDailyFirstAccessLog(signOut, {
      ...(page !== undefined && { page: page.toString() }),
    })
  );

  return {
    data: data?.data,
    headers: data?.headers,
    mutate,
    isLoading,
  };
};
